(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteTwoFactorController', DeleteTwoFactorController);

    DeleteTwoFactorController.$inject = ['$state', '$uibModalInstance', 'pagingParams', 'User'];

    function DeleteTwoFactorController($state, $uibModalInstance, pagingParams, User) {
        var vm = this;

        pagingParams.twoFactorEmail;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirm = function () {
            User.getTOTP({twoFactorEmail: pagingParams.twoFactorEmail}, onSuccess);
        };

        function onSuccess() {
            User.set2FEmail({twoFactorEmail: true});
            $uibModalInstance.close(true);
        }

    }
})();
